export function formatAuthError(errResponse, t) {
  if (errResponse?.errors && Array.isArray(errResponse.errors)) {
    return errResponse.errors.map(e => e.msg).join(', ');
  }

  const errorCode = errResponse?.error || errResponse;

  switch (errorCode) {
    case 'emailExists':
      return t('auth.errors.emailExists');
    case 'serverError':
    case 'auth.errors.serverError':
      return t('auth.errors.serverError');
    case 'Invalid credentials':
    case 'auth.errors.invalidCredentials':
      return t('auth.errors.invalidCredentials');
    default:
      if (typeof errorCode === 'string' && errorCode.length > 0 && !errorCode.startsWith('auth.')) {
        return errorCode;
      }
      return t('auth.errors.generic');
  }
}
